/**
 * How a person is named wherever this site shows or describes one.
 *
 * The `??` operator falls back on null and undefined but not on an empty
 * string, and this database stores an absent display name as "". So
 * `displayName ?? username` returned "" for every real account: the review
 * card rendered a blank author, and the Review structured data emitted
 * `"name": ""`, which Search Console reported as a missing field.
 *
 * One function, used by both, because Google requires the name in the markup
 * to be the name on the page — so they cannot be allowed to disagree.
 */

/** A string that is actually there. Blank and whitespace-only count as absent. */
export function present(value: string | null | undefined): string | null {
  const trimmed = (value ?? "").trim();
  return trimmed === "" ? null : trimmed;
}

export interface NameableAuthor {
  displayName?: string | null;
  username?: string | null;
}

export function personName(author: NameableAuthor, fallback = "Anonymous"): string {
  return present(author.displayName) ?? present(author.username) ?? fallback;
}
